import React from "react";
import ReactDOM from "react-dom";
import Box from "./Box.js";
import Frame from "./Frame.js";
import Nubes from "./Nubes.js";
import "./App.css";
import bgDesktop0 from "../../assets/images/fondo_sin_nubes.png";
import bgMobile0 from "../../assets/images/fondo_sin_nubes_mobile.png";
import bgDesktop1 from "../../assets/images/background_desktop1.png";
import bgMobile1 from "../../assets/images/background_mobile1.png";
import correctAudio from "../../assets/sound/narracion/CORRECTO.mp3";
import incorrectAudio from "../../assets/sound/narracion/INCORRECTO.mp3";
import initAudio from "../../assets/sound/narracion/INICIA JUEGO.mp3";
import Fin from "../Fin";

const defaultStyles = {
  overflow: "hidden",
  width: "30%",
  color: "white",
  display: "flex",
  position: "absolute",
  justifyContent: "center",
  alignItems: "center",
  // fontSize: "2em",
  fontFamily: "'Kanit', sans-serif",
  textTransform: "uppercase",
};

const total_words = [
  "apio",
  "bicicleta",
  "calcetín",
  "cama",
  "camión",
  "camisa",
  "casa",
  "chancho",
  "conejo",
  "dado",
  "dedo",
  "delfín",
  "duende",
  "escalera",
  "estrella",
  "foca",
  "guante",
  "hipopótamo",
  "lápiz",
  "lupa",
  "manzana",
  "zapatilla",
  "cometa",
  "tiburón",
  "murciélago",
  "ocho",
  "pala",
  "pelota",
  "pera",
  "piano",
  "pipa",
  "pulpo",
  "queso",
  "quitasol",
  "raqueta",
  "sol",
  "tigre",
  "toro",
  "vaca",
  "abuela",
  "árbol",
  "ardilla",
  "ballena",
  "caballo",
  "castillo",
  "cebolla",
  "galleta",
  "gallina",
  "grillo",
  "helado",
  "hueso",
  "llama",
  "llave",
  "olla",
  "reloj",
  "silla",
  "tortuga",
  "vaca",
  "vestido",
];

const principal_words = [
  "abuela",
  "árbol",
  "ardilla",
  "ballena",
  "caballo",
  "castillo",
  "cebolla",
  "galleta",
  "gallina",
  "grillo",
  "helado",
  "hueso",
  "llama",
  "llave",
  "olla",
  "reloj",
  "silla",
  "tortuga",
  "vaca",
  "vestido",
];

export default class TrailsExample extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    let words = [];
    words = principal_words.sort(function () {
      return Math.random() - 0.5;
    });
    this.state = {
      items: words.slice(),
      originalItems: words.slice(),
      referencias: [],
      duration: 7000,
      activeWords: [],
      delay: 6000,
      frames: ["", "", ""],
      frameA: React.createRef(),
      frameB: React.createRef(),
      frameC: React.createRef(),
      framePoint: React.createRef(),
    };
    this.leave = this.leave.bind(this);
    this.respuesta = this.respuesta.bind(this);
    this.setActive = this.setActive.bind(this);
  }

  componentDidMount() {
    let referencias = this.state.items.map(function (element) {
      return React.createRef();
    });
    this.setState({ referencias });
  }

  leave(word) {
    let index = this.state.items.indexOf(word);
    if (index >= 0) {
      if (this.state.activeWords.indexOf(index) >= 0) {
        let correct_audio = new Audio(correctAudio);
        correct_audio.currentTime = 0;
        correct_audio.play();
        this.state.framePoint.current.incrementPoint();
        this.state.referencias[index].current.destroy();
        let items = this.state.items;
        items[index] = "";
        this.setState({ items });
      }
    } else {
      let incorrect_audio = new Audio(incorrectAudio);
      incorrect_audio.currentTime = 0;
      incorrect_audio.play();
    }
  }

  setActive(index) {
    let aux_index = total_words.indexOf(principal_words[index]);
    let items = total_words;
    let frames = this.state.frames;
    let indices = [];
    for (let element in frames) {
      while (true) {
        let aux = Math.floor(Math.random() * (items.length - 0) + 0);
        if (indices.indexOf(aux) < 0 && aux !== aux_index && principal_words.indexOf(items[aux])<0) {
          indices[element] = aux;
          break;
        }
      }
    }

    this.state.framePoint.current.refresh();

    indices[Math.floor(Math.random() * (indices.length - 0) + 0)] = aux_index;
    if (this.state.frameA !== null) {
      this.state.frameA.current.changeValue(items[indices[0]]);
    }
    if (this.state.frameB !== null) {
      this.state.frameB.current.changeValue(items[indices[1]]);
    }
    if (this.state.frameC !== null) {
      this.state.frameC.current.changeValue(items[indices[2]]);
    }

    let activeWords = this.state.activeWords;
    if (activeWords.indexOf(index) < 0) {
      activeWords.push(index);
      this.setState({ activeWords });
    }
  }
  setInactive(index) {
    let activeWords = this.state.activeWords;
    if (activeWords.indexOf(index) >= 0) {
      let index2 = activeWords.indexOf(index);
      activeWords.splice(index2, 1);
      this.setState({ activeWords });
    }
    if (index === this.state.items.length - 1) {
      if (this.state.framePoint.current !== null) {
        this.props.music.pause();

        const element = (
          <Fin
            puntos={this.state.framePoint.current.state.frame}
            final_audio={this.props.final_audio}
            final_audio_podios={this.props.final_audio_podios}
            total={principal_words.length}

          />
        );
        ReactDOM.render(element, document.getElementById("root"));
      }
    }
  }

  respuesta(frame) {
    let word = this.state.frameA.current.state.frame;
    if (frame === "B") {
      word = this.state.frameB.current.state.frame;
    } else if (frame === "C") {
      word = this.state.frameC.current.state.frame;
    }
    this.leave(word);
  }

  render() {
    this.props.music.currentTime = 0;
    this.props.music.volume = 0.3;
    this.props.music.play();
    this.props.init_audio.play();
    return (
      <div className="background0">
        <div
          style={{
            // backgroundColor: "#247BA0",
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          {/* {(window.innerWidth > 480) &
            (window.innerWidth / window.innerHeight > 1) ? (
              <div>
                <img
                  src={bgDesktop0}
                  className="background-image0"
                  alt="background"
                />{" "}
                <img
                  src={bgDesktop1}
                  className="background-image1"
                  alt="background"
                />{" "}
              </div>
            ) : (
              <div>
                <img
                  src={bgMobile0}
                  className="background-image0"
                  alt="background"
                />{" "}
                <img
                  src={bgMobile1}
                  className="background-image1"
                  alt="background"
                />{" "}
              </div>
            )} */}

          {this.state.items.map((word, index) => (
            <Box
              ref={this.state.referencias[index]}
              word={word}
              index={index}
              duration={this.state.duration}
              delay={this.state.delay}
              key={index}
            >
              {setTimeout(() => {
                this.setActive(index);
              }, index * this.state.delay + 1500)}
              {setTimeout(() => {
                this.setInactive(index);
              }, index * this.state.delay + this.state.duration + 2500)}
            </Box>
          ))}
          <div>
            <Frame ref={this.state.framePoint} id={4} frame={0}></Frame>
          </div>
          <div id="A" onClick={() => this.respuesta("A")}>
            <Frame
              ref={this.state.frameA}
              id={0}
              frame={this.state.frames[0]}
            ></Frame>
          </div>
          <div onClick={() => this.respuesta("B")}>
            <Frame
              ref={this.state.frameB}
              id={1}
              frame={this.state.frames[1]}
            ></Frame>
          </div>
          <div onClick={() => this.respuesta("C")}>
            <Frame
              ref={this.state.frameC}
              id={2}
              frame={this.state.frames[2]}
            ></Frame>
          </div>
          <Nubes />
        </div>
        <div className="background1"></div>
      </div>
    );
  }
}
